export { renderDivider as renderNavDivider } from '../../Divider';
